// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #region orderInformationRight */

.EditOrder_orderInformationRight__l2Udt {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    width: 100%;
    background-color: var(--color-neutral-100);
    color: var(--color-neutral-900);
    border-radius: var(--radius-global);
    border: 1px solid var(--color-neutral-400);
}

.EditOrder_orderInformationRight__l2Udt>section {
    display: flex;
    width: 100%;
    background-color:rgba(243, 245, 253, 1);
    border-bottom: solid 1px var(--color-neutral-900);
    gap: 24px;
}

.EditOrder_orderInformationRight__l2Udt>section>button {
    width: calc(50% - 12px);
    text-align: center;
    padding: 16px;


}


.EditOrder_orderInformationRight__l2Udt>div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 16px;
    padding: 16px;
}

.EditOrder_orderInformationRight__l2Udt>div>textarea {
    border: solid 1px var(--color-neutral-900);
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.EditOrder_selectItem__q7Ah2>select {
    width: 100%;
    height: 48px;
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.EditOrder_selectItem__q7Ah2 a,
.EditOrder_selectradio__g3I4L a,
.EditOrder_completeList__-3Qiv a {
    color: var(--color-info) !important;
    cursor: pointer;
}

.EditOrder_selectradio__g3I4L>div div {
    display: flex;
    gap: 8px;
}

.EditOrder_completeListContainer__lv57k {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 5px 5px 10px;
    gap: 10px;
    max-height: 290px;
    overflow: auto;
    pointer-events: auto !important;
}

.EditOrder_completeList__-3Qiv>p,
.EditOrder_completeListContainer__lv57k>.EditOrder_completeListItem__6pMlC {
    background: #D9D9D9;
    width: 100%;
    text-align: center;
    padding: 8px;
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.EditOrder_completeListContainer__lv57k .EditOrder_completeListItem__6pMlC>div {
    display: flex;
    gap: 24px;

}


.EditOrder_completeListContainer__lv57k>div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
}

.EditOrder_completeListContainer__lv57k>div:nth-child(1) button {
    display: flex;
    align-items: center;
    gap: 16px;
}

/* #endregion orderInformationRight */

/* #region orderInformationLeft */

.EditOrder_orderInformationLeftContainer__4fdEp {
    width: 100%;
    height: auto;
}

.EditOrder_orderInformationLeftContainer2__srW3t {
    width: 100%;
    height: auto;
}

.EditOrder_orderInformationLeft__eFj-H {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 10px;
}

.EditOrder_orderPreview__Hf1MM {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--color-neutral-100);
    color: var(--color-neutral-900);
    border-radius: var(--radius-global);
    border: 1px solid var(--color-neutral-400);
    padding: 10px 15px;
    gap: 10px;
    /* overflow: hidden; */
    pointer-events: auto !important;
}

.EditOrder_orderPreviewNoPadding__VRyBy {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--color-neutral-100);
    color: var(--color-neutral-900);
    border-radius: var(--radius-global);
    border: 1px solid var(--color-neutral-400);
    padding: 0;
    gap: 10px;
    /* overflow: hidden; */
}

.EditOrder_offlineImg__9pl6f {
    width: 100%;
    height: 300px;
    object-fit: cover;
    border-radius: var(--radius-global);
}

.EditOrder_orderPreviewImg__ddNJY {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.EditOrder_orderPreviewImg__ddNJY iframe {
    width: 100% !important;
    height: 300px !important;
    overflow: hidden;
}

.EditOrder_orderPreviewImg__ddNJY x3d {
    width: 100% !important;
    height: 300px !important;
}

.EditOrder_orderPreviewImgAttr__-GC-E {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;

}

.EditOrder_orderPreviewImgAttrRadio__ySxoq {
    justify-content: flex-start !important;
    gap: 8px;
}

.EditOrder_orderPreviewImgAttr__-GC-E>div {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.EditOrder_orderPreviewImgAttr__-GC-E>div>div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(217, 217, 217, 0.50);
    padding: 8px;
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.EditOrder_orderPreviewImgAttr__-GC-E>div>div>div {
    width: 120px;
}

.EditOrder_orderPreviewController__lTfQw {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* flex-wrap: wrap; */
    gap: 15px;
}

.EditOrder_orderPreviewController__lTfQw button {
    padding: 0 0.25rem;
}

.EditOrder_activeButton__fni\\+i {
    padding: 0.25rem !important;
    border: 1px solid black;
    border-radius: 10px;
}

.EditOrder_orderPreviewController__lTfQw svg {
    width: 22px;
    height: 22px;
}

.EditOrder_orderInformationFurther__IduPX {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    background-color: var(--color-neutral-100);
    color: var(--color-neutral-900);
    border-radius: var(--radius-global);
    border: 1px solid var(--color-neutral-400);
    padding: 16px 24px;
}

.EditOrder_calculatePriceNumber__MdLdz {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
}

.EditOrder_calculateNumber__DCzWv {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;

}

.EditOrder_calculateNumber__DCzWv>div {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.EditOrder_calculateNumber__DCzWv .EditOrder_btn__uARYH {
    display: flex;
    justify-content: space-between;
    background: var(--color-white);
    padding: 8px 16px;
    border: solid 1px var(--color-neutral-900);
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.EditOrder_calculateNumber__DCzWv .EditOrder_btn__uARYH>button {
    background: var(--color-neutral-400);
    color: var(--color-white);
    width: 24px;
    height: 24px;
    border-radius: var(--radius-small);
    -webkit-border-radius: var(--radius-small);
    -moz-border-radius: var(--radius-small);
    -ms-border-radius: var(--radius-small);
    -o-border-radius: var(--radius-small);
}
.EditOrder_calculateNumber__DCzWv .EditOrder_btn__uARYH input{
    width: 40px;
    text-align: center;
}

.EditOrder_calculateNumber__DCzWv>div>div {
    width: 150px;
}

.EditOrder_calculatePrice__EwLFS {
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: center;
}

.EditOrder_orderInformationFurther__IduPX>a {
    color: var(--color-info) !important;
}

.EditOrder_orderInformationBtn__OB1iH {
    display: flex;
    justify-content: space-between;
}

.EditOrder_orderInformationBtn__OB1iH>button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 8px;
    font-size: 1rem;
    background-color: var(--color-primary);
    color: var(--color-white);
    border-radius: var(--radius-global);
    gap: 4px;
    margin-top: 16px;
}

.EditOrder_orderInformationBtn__OB1iH>button:nth-child(1) {
    width: calc(60% - 12px);
}

.EditOrder_orderInformationBtn__OB1iH>button:nth-child(2) {
    width: calc(40% - 12px);
}
/* #endregion orderInformationLeft */

.EditOrder_showDimensions__9N2Jk {
    padding: 0 1rem;
    text-align: center;
    min-width: 200px;
    direction: ltr !important;
}


/* #region media orderInformation */
@media screen and (min-width :768px) {
    .EditOrder_selectItem__q7Ah2>div,
    .EditOrder_selectradio__g3I4L>div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
    }


    .EditOrder_orderPreviewImg__ddNJY img {
        width: 80%;
    }


    .EditOrder_calculatePriceNumber__MdLdz {
        flex-direction: row;
    }

    .EditOrder_calculatePriceNumber__MdLdz>div {
        width: calc(50% - 24px);
    }
}

@media screen and (min-width : 992px) {
    .EditOrder_orderInformationRight__l2Udt {
        width: calc(45% - 8px);
    }

    .EditOrder_orderInformationLeft__eFj-H {
        position: sticky;
        top: 120px;
    }

    .EditOrder_orderInformationLeftContainer__4fdEp {
        width: calc(55% - 8px);
        height: 1704px;
    }

    .EditOrder_orderInformationLeftContainer2__srW3t {
        width: calc(55% - 8px);
        height: auto;
    }
}
/* #endregion media orderInformation */

/* #region twoDimensionalMapModal */
.EditOrder_twoDimensionalMapModal__1c07K {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    gap: 24px;
}

.EditOrder_twoDimensionalMapModal__1c07K .EditOrder_btnclose__2o11o {
    position: absolute;
    top: 0;
    right: 0;
}
/* #endregion twoDimensionalMapModal */

/* #region priceModalHeader */
.EditOrder_priceModal__HEspY {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.EditOrder_priceModalHeader__WTOJY {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.EditOrder_priceModalHeader__WTOJY>div:nth-child(1) {
    width: 100%;
}

.EditOrder_priceModalHeader__WTOJY>div:nth-child(2) {
    width: 30%;
    border: solid 1px var(--color-neutral-900);
    border-radius: var(--radius-global);
    overflow: hidden;
    display: none;
}

.EditOrder_priceModalHeader__WTOJY>div:nth-child(2) img {
    width: 100%;
}

.EditOrder_priceModalTab__f4UtM {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
}

.EditOrder_priceModalTab__f4UtM>div {
    display: flex;
    flex-wrap: wrap;
}

.EditOrder_priceModalTab__f4UtM>div>button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    gap: 16px;
    border: solid 1px var(--color-neutral-900);
    padding: 4px 16px;
}

@media screen and (min-width : 768px) {
    .EditOrder_priceModalHeader__WTOJY>div:nth-child(1) {
        width: 65%;
    }

    .EditOrder_priceModalHeader__WTOJY>div:nth-child(2) {
        display: block;
    }

    .EditOrder_priceModalTab__f4UtM {
        flex-direction: row;
        align-items: center;
    }

    .EditOrder_priceModalTab__f4UtM>div>button {
        width: -moz-fit-content;
        width: fit-content;
    }
}

.EditOrder_priceModalTable__0wvZa {
    width: 100%;
    height: 100%;
    max-height: 260px;
    overflow: auto;
    margin-bottom: -20px;
}

.EditOrder_priceModalTable__0wvZa table,
.EditOrder_priceModalTable__0wvZa th,
.EditOrder_priceModalTable__0wvZa td {
    border: 1px solid black !important;
    border-collapse: collapse !important;
    text-align: center !important;
    padding: 4px !important;
}

.EditOrder_priceModalTable__0wvZa tbody tr {
    cursor: pointer;
}

.EditOrder_priceModalTable__0wvZa tfoot tr:nth-child(2) {
    cursor: pointer;
}

.EditOrder_priceModalTable__0wvZa table input {
    max-width: 80px !important;
    text-align: center !important;
}

/* #endregion priceModalHeader */
.EditOrder_hoveredShapeModal__jDXsP {
    position: fixed;
    width: 300px;
    /* padding: 1rem; */
    border-radius: var(--radius-global);
    background-color: var(--color-neutral-900);
    z-index: 999;
    direction: rtl;
    pointer-events: none;
    display: none;
}

.EditOrder_hoveredShapeModal__jDXsP table {
    border: none;
}

.EditOrder_hoveredShapeModal__jDXsP table :is(th, td) {
    width: 50%;
}

.EditOrder_hoveredShapeModal__jDXsP table :is(td, th):first-child {
    border-left: 1px solid white !important;
}

.EditOrder_hoveredShapeModal__jDXsP table :is(td, th) {
    color: white !important;
    padding: 0.5rem 1rem !important;
}

.EditOrder_hoveredShapeModal__jDXsP table thead tr {
    border-bottom: 3px solid white !important;
}

.EditOrder_hoveredShapeModal__jDXsP table tbody tr:not(:last-child) {
    border-bottom: 1px solid white !important;
}

.EditOrder_activePlanTableRow__hQUD0 {
    background-color: var(--color-blue) !important;
}

.EditOrder_warningBtn__u593p {
    background-color: #E98862 !important;
    color: var(--color-white);
}

.EditOrder_warningBtnBack__c0vir {
    background-color: #E98862 !important;
    color: var(--color-white);
    pointer-events: auto !important;
}

.EditOrder_btnBack__Fd-Wc {
    pointer-events: auto !important;
}

.EditOrder_infoColor__Km4U- {
    color: var(--color-info) !important;
    font-weight: bold !important;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Styles/EditOrder.module.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,0CAA0C;IAC1C,+BAA+B;IAC/B,mCAAmC;IACnC,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uCAAuC;IACvC,iDAAiD;IACjD,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;;;AAGjB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,0CAA0C;IAC1C,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;;;IAGI,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,+BAA+B;AACnC;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,SAAS;;AAEb;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,qCAAqC;;AAErC,iCAAiC;;AAEjC;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,+BAA+B;IAC/B,mCAAmC;IACnC,0CAA0C;IAC1C,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,+BAA+B;IAC/B,mCAAmC;IACnC,0CAA0C;IAC1C,UAAU;IACV,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;;AAEZ;;AAEA;IACI,sCAAsC;IACtC,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qCAAqC;IACrC,YAAY;IACZ,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,0CAA0C;IAC1C,+BAA+B;IAC/B,mCAAmC;IACnC,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;;AAEb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,8BAA8B;IAC9B,iBAAiB;IACjB,0CAA0C;IAC1C,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;AACzC;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,yBAAyB;IACzB,mCAAmC;IACnC,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;AACA,oCAAoC;;AAEpC;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;;AAGA,mCAAmC;AACnC;IACI;;QAEI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,eAAe;QACf,WAAW;IACf;;;IAGA;QACI,UAAU;IACd;;;IAGA;QACI,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;AACJ;AACA,sCAAsC;;AAEtC,mCAAmC;AACnC;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;AACA,sCAAsC;;AAEtC,6BAA6B;AAC7B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,0CAA0C;IAC1C,mCAAmC;IACnC,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,uBAAkB;QAAlB,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,oBAAoB;AACxB;;AAEA;;;IAGI,kCAAkC;IAClC,oCAAoC;IACpC,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,mCAAmC;IACnC,0CAA0C;IAC1C,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;IACnC,4BAA4B;IAC5B,eAAe;AACnB","sourcesContent":["/* #region orderInformationRight */\n\n.orderInformationRight {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    overflow: hidden;\n    width: 100%;\n    background-color: var(--color-neutral-100);\n    color: var(--color-neutral-900);\n    border-radius: var(--radius-global);\n    border: 1px solid var(--color-neutral-400);\n}\n\n.orderInformationRight>section {\n    display: flex;\n    width: 100%;\n    background-color:rgba(243, 245, 253, 1);\n    border-bottom: solid 1px var(--color-neutral-900);\n    gap: 24px;\n}\n\n.orderInformationRight>section>button {\n    width: calc(50% - 12px);\n    text-align: center;\n    padding: 16px;\n\n\n}\n\n\n.orderInformationRight>div {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    gap: 16px;\n    padding: 16px;\n}\n\n.orderInformationRight>div>textarea {\n    border: solid 1px var(--color-neutral-900);\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.selectItem>select {\n    width: 100%;\n    height: 48px;\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.selectItem a,\n.selectradio a,\n.completeList a {\n    color: var(--color-info) !important;\n    cursor: pointer;\n}\n\n.selectradio>div div {\n    display: flex;\n    gap: 8px;\n}\n\n.completeListContainer {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 5px 5px 10px;\n    gap: 10px;\n    max-height: 290px;\n    overflow: auto;\n    pointer-events: auto !important;\n}\n\n.completeList>p,\n.completeListContainer>.completeListItem {\n    background: #D9D9D9;\n    width: 100%;\n    text-align: center;\n    padding: 8px;\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.completeListContainer .completeListItem>div {\n    display: flex;\n    gap: 24px;\n\n}\n\n\n.completeListContainer>div {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    width: 100%;\n}\n\n.completeListContainer>div:nth-child(1) button {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n/* #endregion orderInformationRight */\n\n/* #region orderInformationLeft */\n\n.orderInformationLeftContainer {\n    width: 100%;\n    height: auto;\n}\n\n.orderInformationLeftContainer2 {\n    width: 100%;\n    height: auto;\n}\n\n.orderInformationLeft {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    gap: 10px;\n}\n\n.orderPreview {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--color-neutral-100);\n    color: var(--color-neutral-900);\n    border-radius: var(--radius-global);\n    border: 1px solid var(--color-neutral-400);\n    padding: 10px 15px;\n    gap: 10px;\n    /* overflow: hidden; */\n    pointer-events: auto !important;\n}\n\n.orderPreviewNoPadding {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--color-neutral-100);\n    color: var(--color-neutral-900);\n    border-radius: var(--radius-global);\n    border: 1px solid var(--color-neutral-400);\n    padding: 0;\n    gap: 10px;\n    /* overflow: hidden; */\n}\n\n.offlineImg {\n    width: 100%;\n    height: 300px;\n    object-fit: cover;\n    border-radius: var(--radius-global);\n}\n\n.orderPreviewImg {\n    position: relative;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.orderPreviewImg iframe {\n    width: 100% !important;\n    height: 300px !important;\n    overflow: hidden;\n}\n\n.orderPreviewImg x3d {\n    width: 100% !important;\n    height: 300px !important;\n}\n\n.orderPreviewImgAttr {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n}\n\n.orderPreviewImgAttrRadio {\n    justify-content: flex-start !important;\n    gap: 8px;\n}\n\n.orderPreviewImgAttr>div {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.orderPreviewImgAttr>div>div {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: rgba(217, 217, 217, 0.50);\n    padding: 8px;\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.orderPreviewImgAttr>div>div>div {\n    width: 120px;\n}\n\n.orderPreviewController {\n    height: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    /* flex-wrap: wrap; */\n    gap: 15px;\n}\n\n.orderPreviewController button {\n    padding: 0 0.25rem;\n}\n\n.activeButton {\n    padding: 0.25rem !important;\n    border: 1px solid black;\n    border-radius: 10px;\n}\n\n.orderPreviewController svg {\n    width: 22px;\n    height: 22px;\n}\n\n.orderInformationFurther {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n    background-color: var(--color-neutral-100);\n    color: var(--color-neutral-900);\n    border-radius: var(--radius-global);\n    border: 1px solid var(--color-neutral-400);\n    padding: 16px 24px;\n}\n\n.calculatePriceNumber {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 24px;\n}\n\n.calculateNumber {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 16px;\n\n}\n\n.calculateNumber>div {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.calculateNumber .btn {\n    display: flex;\n    justify-content: space-between;\n    background: var(--color-white);\n    padding: 8px 16px;\n    border: solid 1px var(--color-neutral-900);\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.calculateNumber .btn>button {\n    background: var(--color-neutral-400);\n    color: var(--color-white);\n    width: 24px;\n    height: 24px;\n    border-radius: var(--radius-small);\n    -webkit-border-radius: var(--radius-small);\n    -moz-border-radius: var(--radius-small);\n    -ms-border-radius: var(--radius-small);\n    -o-border-radius: var(--radius-small);\n}\n.calculateNumber .btn input{\n    width: 40px;\n    text-align: center;\n}\n\n.calculateNumber>div>div {\n    width: 150px;\n}\n\n.calculatePrice {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    text-align: center;\n}\n\n.orderInformationFurther>a {\n    color: var(--color-info) !important;\n}\n\n.orderInformationBtn {\n    display: flex;\n    justify-content: space-between;\n}\n\n.orderInformationBtn>button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 8px;\n    font-size: 1rem;\n    background-color: var(--color-primary);\n    color: var(--color-white);\n    border-radius: var(--radius-global);\n    gap: 4px;\n    margin-top: 16px;\n}\n\n.orderInformationBtn>button:nth-child(1) {\n    width: calc(60% - 12px);\n}\n\n.orderInformationBtn>button:nth-child(2) {\n    width: calc(40% - 12px);\n}\n/* #endregion orderInformationLeft */\n\n.showDimensions {\n    padding: 0 1rem;\n    text-align: center;\n    min-width: 200px;\n    direction: ltr !important;\n}\n\n\n/* #region media orderInformation */\n@media screen and (min-width :768px) {\n    .selectItem>div,\n    .selectradio>div {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        flex-wrap: wrap;\n        width: 100%;\n    }\n\n\n    .orderPreviewImg img {\n        width: 80%;\n    }\n\n\n    .calculatePriceNumber {\n        flex-direction: row;\n    }\n\n    .calculatePriceNumber>div {\n        width: calc(50% - 24px);\n    }\n}\n\n@media screen and (min-width : 992px) {\n    .orderInformationRight {\n        width: calc(45% - 8px);\n    }\n\n    .orderInformationLeft {\n        position: sticky;\n        top: 120px;\n    }\n\n    .orderInformationLeftContainer {\n        width: calc(55% - 8px);\n        height: 1704px;\n    }\n\n    .orderInformationLeftContainer2 {\n        width: calc(55% - 8px);\n        height: auto;\n    }\n}\n/* #endregion media orderInformation */\n\n/* #region twoDimensionalMapModal */\n.twoDimensionalMapModal {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    text-align: center;\n    gap: 24px;\n}\n\n.twoDimensionalMapModal .btnclose {\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n/* #endregion twoDimensionalMapModal */\n\n/* #region priceModalHeader */\n.priceModal {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.priceModalHeader {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.priceModalHeader>div:nth-child(1) {\n    width: 100%;\n}\n\n.priceModalHeader>div:nth-child(2) {\n    width: 30%;\n    border: solid 1px var(--color-neutral-900);\n    border-radius: var(--radius-global);\n    overflow: hidden;\n    display: none;\n}\n\n.priceModalHeader>div:nth-child(2) img {\n    width: 100%;\n}\n\n.priceModalTab {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.priceModalTab>div {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.priceModalTab>div>button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 50%;\n    gap: 16px;\n    border: solid 1px var(--color-neutral-900);\n    padding: 4px 16px;\n}\n\n@media screen and (min-width : 768px) {\n    .priceModalHeader>div:nth-child(1) {\n        width: 65%;\n    }\n\n    .priceModalHeader>div:nth-child(2) {\n        display: block;\n    }\n\n    .priceModalTab {\n        flex-direction: row;\n        align-items: center;\n    }\n\n    .priceModalTab>div>button {\n        width: fit-content;\n    }\n}\n\n.priceModalTable {\n    width: 100%;\n    height: 100%;\n    max-height: 260px;\n    overflow: auto;\n    margin-bottom: -20px;\n}\n\n.priceModalTable table,\n.priceModalTable th,\n.priceModalTable td {\n    border: 1px solid black !important;\n    border-collapse: collapse !important;\n    text-align: center !important;\n    padding: 4px !important;\n}\n\n.priceModalTable tbody tr {\n    cursor: pointer;\n}\n\n.priceModalTable tfoot tr:nth-child(2) {\n    cursor: pointer;\n}\n\n.priceModalTable table input {\n    max-width: 80px !important;\n    text-align: center !important;\n}\n\n/* #endregion priceModalHeader */\n.hoveredShapeModal {\n    position: fixed;\n    width: 300px;\n    /* padding: 1rem; */\n    border-radius: var(--radius-global);\n    background-color: var(--color-neutral-900);\n    z-index: 999;\n    direction: rtl;\n    pointer-events: none;\n    display: none;\n}\n\n.hoveredShapeModal table {\n    border: none;\n}\n\n.hoveredShapeModal table :is(th, td) {\n    width: 50%;\n}\n\n.hoveredShapeModal table :is(td, th):first-child {\n    border-left: 1px solid white !important;\n}\n\n.hoveredShapeModal table :is(td, th) {\n    color: white !important;\n    padding: 0.5rem 1rem !important;\n}\n\n.hoveredShapeModal table thead tr {\n    border-bottom: 3px solid white !important;\n}\n\n.hoveredShapeModal table tbody tr:not(:last-child) {\n    border-bottom: 1px solid white !important;\n}\n\n.activePlanTableRow {\n    background-color: var(--color-blue) !important;\n}\n\n.warningBtn {\n    background-color: #E98862 !important;\n    color: var(--color-white);\n}\n\n.warningBtnBack {\n    background-color: #E98862 !important;\n    color: var(--color-white);\n    pointer-events: auto !important;\n}\n\n.btnBack {\n    pointer-events: auto !important;\n}\n\n.infoColor {\n    color: var(--color-info) !important;\n    font-weight: bold !important;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderInformationRight": `EditOrder_orderInformationRight__l2Udt`,
	"selectItem": `EditOrder_selectItem__q7Ah2`,
	"selectradio": `EditOrder_selectradio__g3I4L`,
	"completeList": `EditOrder_completeList__-3Qiv`,
	"completeListContainer": `EditOrder_completeListContainer__lv57k`,
	"completeListItem": `EditOrder_completeListItem__6pMlC`,
	"orderInformationLeftContainer": `EditOrder_orderInformationLeftContainer__4fdEp`,
	"orderInformationLeftContainer2": `EditOrder_orderInformationLeftContainer2__srW3t`,
	"orderInformationLeft": `EditOrder_orderInformationLeft__eFj-H`,
	"orderPreview": `EditOrder_orderPreview__Hf1MM`,
	"orderPreviewNoPadding": `EditOrder_orderPreviewNoPadding__VRyBy`,
	"offlineImg": `EditOrder_offlineImg__9pl6f`,
	"orderPreviewImg": `EditOrder_orderPreviewImg__ddNJY`,
	"orderPreviewImgAttr": `EditOrder_orderPreviewImgAttr__-GC-E`,
	"orderPreviewImgAttrRadio": `EditOrder_orderPreviewImgAttrRadio__ySxoq`,
	"orderPreviewController": `EditOrder_orderPreviewController__lTfQw`,
	"activeButton": `EditOrder_activeButton__fni+i`,
	"orderInformationFurther": `EditOrder_orderInformationFurther__IduPX`,
	"calculatePriceNumber": `EditOrder_calculatePriceNumber__MdLdz`,
	"calculateNumber": `EditOrder_calculateNumber__DCzWv`,
	"btn": `EditOrder_btn__uARYH`,
	"calculatePrice": `EditOrder_calculatePrice__EwLFS`,
	"orderInformationBtn": `EditOrder_orderInformationBtn__OB1iH`,
	"showDimensions": `EditOrder_showDimensions__9N2Jk`,
	"twoDimensionalMapModal": `EditOrder_twoDimensionalMapModal__1c07K`,
	"btnclose": `EditOrder_btnclose__2o11o`,
	"priceModal": `EditOrder_priceModal__HEspY`,
	"priceModalHeader": `EditOrder_priceModalHeader__WTOJY`,
	"priceModalTab": `EditOrder_priceModalTab__f4UtM`,
	"priceModalTable": `EditOrder_priceModalTable__0wvZa`,
	"hoveredShapeModal": `EditOrder_hoveredShapeModal__jDXsP`,
	"activePlanTableRow": `EditOrder_activePlanTableRow__hQUD0`,
	"warningBtn": `EditOrder_warningBtn__u593p`,
	"warningBtnBack": `EditOrder_warningBtnBack__c0vir`,
	"btnBack": `EditOrder_btnBack__Fd-Wc`,
	"infoColor": `EditOrder_infoColor__Km4U-`
};
export default ___CSS_LOADER_EXPORT___;
